import React from 'react'

export default ({ origin, onRedactRequested }) => {

  return (
    origin ? (
      <div className="popup-toolbar fade-in" style={{left: origin.x, top: origin.y}}>
        <button onClick={onRedactRequested} className="popup-toolbar-button neutral">
          Redact
        </button>
      </div>
    )
    : null
  )
}
